import { cn } from '@/lib/utils'

/**
 * Thin segmented bar — each colored segment sized by its share of the total.
 * A trailing track segment fills the remainder so every bar reads full-width.
 *
 * Shared by the chat welcome stat cards and the Frameworks lens cards so both
 * render multi-status posture identically (Rule 7). Colors stay caller-supplied
 * (PROGRESS_COLORS) so the bar itself is status-agnostic.
 */
export function SegBar({
  segments,
  className,
}: {
  segments: { value: number; color?: string; className?: string }[]
  className?: string
}) {
  const total = segments.reduce((sum, s) => sum + Math.max(0, s.value), 0)
  return (
    <span
      className={cn(
        'flex h-1.5 w-full gap-[2px] overflow-hidden rounded-full bg-muted',
        className
      )}
    >
      {total > 0 &&
        segments.map((s, i) =>
          s.value > 0 ? (
            <span
              key={i}
              className={cn('h-full rounded-full', s.className)}
              style={{
                width: `${(s.value / total) * 100}%`,
                ...(s.color ? { backgroundColor: s.color } : {}),
              }}
            />
          ) : null
        )}
    </span>
  )
}
